import { ApolloError } from '@apollo/client';

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Pagination,
  LoadedContent,
  TableContainer,
  TableHeaderBulkSelectCheckbox,
} from '@occc-app/design-system';
import { RetailerNetworkLocationFragment } from '@occc/graphql';
import {
  IPaginationProps,
  PaginationHandler,
  PaginationInfo,
} from '@occc-app/hooks/usePaginatedQuery';
import { useBulkSelect } from '@occc-app/hooks/useBulkSelect';

import RetailerNetworkLocationsTableItem from './retailer-network-locations-table-item.component';

type RetailerNetworkLocationsTableProps = ReturnType<typeof useBulkSelect> & {
  loading: boolean;
  error?: ApolloError;
  data?: RetailerNetworkLocationFragment[];
  paginationProps: IPaginationProps;
  paginationInfo?: PaginationInfo;
  onPageChange?: PaginationHandler;
};

const RetailerNetworkLocationsTable = ({
  loading,
  error,
  data,
  paginationProps,
  bulkSelectedItems,
  handleBulkSelectMultiple,
  handleItemSelect,
}: RetailerNetworkLocationsTableProps) => {
  const currentPageLocationUuids = data?.map((item) => item.location.uuid) || [];

  const renderData = (items: RetailerNetworkLocationFragment[]) => (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell padding='checkbox'>
              <TableHeaderBulkSelectCheckbox
                bulkSelectedItems={bulkSelectedItems}
                handleBulkSelectMultiple={handleBulkSelectMultiple}
                currentPageItems={currentPageLocationUuids}
              />
            </TableCell>
            <TableCell>Site ID</TableCell>
            <TableCell>Site Name (DBA)</TableCell>
            <TableCell>Site Address</TableCell>
            <TableCell>Site Phone Number</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((item) => (
            <RetailerNetworkLocationsTableItem
              location={item.location}
              key={item.location.uuid}
              isItemSelected={bulkSelectedItems.has(item.location.uuid)}
              handleItemSelect={handleItemSelect}
            />
          ))}
        </TableBody>
      </Table>
      <Pagination {...paginationProps} />
    </TableContainer>
  );

  return (
    <LoadedContent<RetailerNetworkLocationFragment>
      error={error}
      loading={loading}
      items={data}
      renderData={renderData}
    />
  );
};

export default RetailerNetworkLocationsTable;
